/**
 *  全新弹幕 设计
 */
import { install } from 'resize-observer';
import log from 'loglevel';
import Plugin from '../core/Plugin';
import { SPEED_ARG } from './barrage/Constants';
import { getTranslateX } from './barrage/utils';
import UUID from '../utils/UUID';
import { bindEventVisibility, detectCssTransition, removeFromParent } from '../utils/Dom';
import { isMobile } from '../../common/Utils';

// api兼容 - ios 13.4 以下
if (!window.ResizeObserver) install();

export default class Danmaku extends Plugin {
  constructor() {
    super();
    // 全局 初始化信息
    this._allConfig = null;

    // 弹幕插件 所需配置信息
    this._barrageConfig = null;

    // 是否 正在播放状态
    this._isPlaying = false;

    // 当前弹幕开关是否开启
    this._isOpen = false;

    // 弹幕渲染队列
    this.renderQueue = [];
    // 声明 弹幕容器
    this.container = null;

    // 弹幕容器 - 高宽
    this.wrapboxWidth = null;
    this.wrapboxHeight = null;

    // 弹幕显示区域高度
    this.displayAreaTop = null;

    // 弹幕队列轮询 - 计时器
    this.renderTimer = null;

    // 弹幕轨道 - 高度 默认： 40
    this.tracksSize = 40;

    // 弹幕轨道 -- 多维数组
    this.tracks = null;

    // 继续执行 时间器
    this.resumeTimer = null;

    // 是否暂停状态
    this.paused = false;
  }

  /**
   *  继承实现
   */
  init(ops = {}) {
    super.init(ops);
    this._allConfig = ops;
    // 从全局 - 初始化信息中，查询 弹幕相关初始化 配置
    this._barrageConfig = JSON.parse(ops[Danmaku.type]);
    this.cssTransition = detectCssTransition();
    if (!this.cssTransition) {
      log.warn('不支持 css3 transition');
      return false;
    }
    // set wrapbox size
    this.resize();
    this.initWrapBox();
    this.exportPublic();

    // 增加事件监听
    bindEventVisibility(
      () => {
        // 必须异步执行，否则恢复后动画速度可能会加快，从而导致弹幕消失或重叠，原因不明
        this._resumeTimer = setTimeout(() => {
          this.resume();
        }, 200);
      },
      () => {
        this.pause();
      }
    );

    this.addEventLisners();
  }

  resize() {
    const wrapbox = document.getElementById(this._allConfig['id']);
    if (wrapbox) {
      this.wrapboxHeight = wrapbox.offsetHeight;
      this.wrapboxWidth = wrapbox.offsetWidth;
      // 变换之后， 重新计算，弹幕轨道
      this.clearBarrage();
    }
    // this.renderQueue = [];
    // To Do 清空队列
  }

  /**
   *  初始化-弹幕轨道
   */
  async computedTracks() {
    let displayAreaTop, displayAreaBottom, displayArea;

    await new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, 500);
    });

    if (this.player.isFullscreen) {
      displayAreaTop =
        window.innerHeight * (this._barrageConfig.positionRange[0] < 0 ? 0 : this._barrageConfig.positionRange[0]);
      displayAreaBottom =
        window.innerHeight * (this._barrageConfig.positionRange[1] > 1 ? 1 : this._barrageConfig.positionRange[1]);
      displayArea = displayAreaBottom - displayAreaTop;
    } else {
      displayAreaTop =
        this.wrapboxHeight * (this._barrageConfig.positionRange[0] < 0 ? 0 : this._barrageConfig.positionRange[0]);
      displayAreaBottom =
        this.wrapboxHeight * (this._barrageConfig.positionRange[1] > 1 ? 1 : this._barrageConfig.positionRange[1]);
      displayArea = displayAreaBottom - displayAreaTop;
    }
    this.displayAreaTop = displayAreaTop;
    this.displayArea = displayArea;

    // log.info( this.wrapboxHeight + 'px', displayAreaTop, this.displayArea);
    // 计算可以显示几行 用弹幕区域总高度 / 弹幕行高
    const count = Math.floor(displayArea / this.tracksSize);
    this.tracks = new Array(count);
    // 创建弹幕显示轨道
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < count; i++) {
      this.tracks[i] = [];
    }

    this.maxRender = count;
    // log.info( '显示- 最多同时显示弹幕数：', this.maxRender);
  }

  /**
   * 创建 弹幕容器
   */
  async initWrapBox() {
    this.wrapbox = document.createElement('div');
    this.wrapbox.setAttribute('id', 'vhy-danmaku-wrapbox');
    const styles = document.createElement('style');
    // styles.innerHTML = `
    //   #vhy-danmaku-wrapbox {
    //     position: absolute;
    //     left: 0;
    //     right: 0;
    //     top: 0;
    //     bottom: 0;
    //     z-index: 3;
    //     overflow: hidden
    //   }
    //   .vhy-danmaku-item{
    //     position: absolute;
    //     line-height: 2;
    //     font-size: 14px;
    //     color:#fff;
    //     white-space: nowrap;
    //     z-index: 10;
    //     cursor: pointer;
    //   }
    //   .vhy-danmaku-item img{
    //     max-height: 120px;
    //   }
    // `;
    styles.appendChild(
      document.createTextNode(
        '#vhy-danmaku-wrapbox {position: absolute;left: 0;right: 0;top: 0;bottom: 0;z-index: 3;overflow: hidden}'
      )
    );
    styles.appendChild(
      document.createTextNode(
        '.vhy-danmaku-item{position: absolute;line-height: 2;font-size: 14px;color:#fff;white-space: nowrap;z-index: 10;cursor: pointer;}'
      )
    );
    styles.appendChild(document.createTextNode('.vhy-danmaku-item img{max-height: 120px;}'));
    document.head.appendChild(styles);
    this.container = this.wrapbox;
    document.getElementById(this._allConfig['id']).appendChild(this.wrapbox);

    const resizeObserver = new ResizeObserver(() => {
      if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        // IE中的兼容处理
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('playerResize', true, false, window, 0);
        window.dispatchEvent(evt);
      } else {
        window.dispatchEvent(new Event('playerResize'));
      }
    });
    resizeObserver.observe(document.querySelector(`#${this._allConfig['id']}`));

    window.addEventListener('playerResize', () => {
      this.resize();
      // if (resizeTimer) {
      //   clearTimeout(resizeTimer);
      // };
      // resizeTimer = setTimeout(() => {
      //   this.wrapboxWidth = this.container.offsetWidth;
      //   this.wrapboxHeight = this.container.offsetHeight;

      //   // this.resize();
      //   this.computedTracks();
      //   this.eachDanmakuNode((node, y, id) => {
      //     const data = this.findData(y, id);
      //     if (data) {
      //       data.startTime = Date.now();
      //       data.totalDistance = data.width + this.wrapboxWidth;

      //       data.rolledDistance = -getTranslateX(node);
      //       // 重新计算滚完剩余距离需要多少时间
      //       data.rollTime = (data.totalDistance - data.rolledDistance) / data.rollSpeed;
      //       node.style.transition = `transform ${data.rollTime}s linear`;
      //       node.style.transform = `translate3d(-${data.totalDistance}px, 0, 0)`;
      //     }
      //   });
      // }, 20);
    });
  }

  /**
   * export Public Methods
   */
  exportPublic() {
    const MethodsMap = [
      'openBarrage',
      'closeBarrage',
      'addBarrage',
      'setBarrageInfo',
      'clearBarrage',
      'barrageState',
      'resize'
    ];

    MethodsMap.forEach(method => {
      this.player[method] = this[method].bind(this);
    });
  }
  // 渲染进- DOM 节点
  renderToDom() {
    let i = 0;
    if (this.maxRender && i < this.renderQueue.length) {
      const data = this.renderQueue[i];
      if (!data) return;
      let node = data.node;
      const container = this.container;
      if (!node) {
        data.node = node = document.createElement('div');
        node.setAttribute('class', 'vhy-danmaku-item');
        node.style.left = '100%';
        node.style.willChange = 'transform';
        // node.innerHTML = data.msg;
        // node.textContent = data.msg;
        node.insertAdjacentHTML('afterbegin', data.msg);
        // 设置弹幕样式
        data.opacity && (node.style.opacity = data.opacity / 100);
        if (data.opacity === 0) {
          node.style.opacity = 0;
        }
        data.textShadow && (node.style.textShadow = data.textShadow);

        if (isMobile()) {
          data.h5FontSize && (node.style.fontSize = `${data.h5FontSize + data.h5Unit}`);
        } else {
          data.fontSize && (node.style.fontSize = `${data.fontSize + data.unit}`);
        }
        data.fontFamily && (node.style.fontFamily = data.fontFamily);
        data.color && (node.style.color = data.color);
        data.backgroundImage && (node.style.backgroundImage = data.backgroundImage);
        data.backgroundColor && (node.style.backgroundColor = data.backgroundColor);
        data.padding && (node.style.paddingLeft = data.padding);
        data.padding && (node.style.paddingRight = data.padding);
        data.border && (node.style.border = data.border);
        // 插入节点
        container.appendChild(node);
        // 计算占用轨道--
        data.useTracks = Math.ceil(node.offsetHeight / this.tracksSize);

        // log.info('本条弹幕预计占用轨道数', data.useTracks);
        // DOM 节点 占用高度 过高时， 直接丢弃此弹幕
        if (data.useTracks > this.tracks.length) {
          this.renderQueue.shift();
          container.removeChild(node);
        }
        data.width = node.offsetWidth;
        // data.height = node.offsetHeight;
        // 自身宽度 + 容器宽度为 整体运动距离
        data.totalDistance = data.width + this.wrapboxWidth;
        // 运动时间
        data.rollTime = data.speed / 1000 || Math.floor(data.totalDistance * SPEED_ARG * (Math.random() * 0.3 + 0.7));
        // 运动速度 总长度 / 时间
        data.rollSpeed = data.totalDistance / data.rollTime;
      }
      // 将弹幕 加入具体空闲轨道
      this.addToTracks(data);

      if (data.y) {
        // this.renderQueue.shift();
        this.renderQueue.splice(i, 1);
        node.setAttribute('data-increaseId', data.increaseId);
        node.setAttribute('data-y', data.y[0]);
        node.style.top = `${data.y[0] * this.tracksSize + this.displayAreaTop}px`;
        node.style[this.cssTransition.css] = `${data.rollTime}s linear`;
        node.style.transform = `translate3d(-${data.totalDistance}px, 0, 0)`;
        node.addEventListener(
          'transitionstart',
          () => {
            data.startTime = Date.now();
          },
          false
        );

        node.addEventListener(
          [this.cssTransition.event],
          () => {
            this.removeFromTrack(data.y, data.increaseId);
            container.removeChild(node);
          },
          false
        );

        node.addEventListener('mouseover', () => {
          node.style.zIndex = 100;
          this.itemPause(node, data.y[0], data.increaseId);
        });
        node.addEventListener('mouseout', () => {
          this.itemResum(node, data.y[0], data.increaseId);
        });

        data.startTime = Date.now() + 80;
      } else {
        i++;
      }
    }
  }

  removeFromTrack(y, id) {
    y.forEach(i => {
      const track = this.tracks[i];
      if (!track) {
        return;
      }
      for (let j = 0; j < track.length; j++) {
        if (track[j].increaseId === id) {
          track.splice(j, 1);
          break;
        }
      }
    });
  }

  addToTracks(data) {
    // 单条轨道
    let track;
    // 轨道的最后一项弹幕数据
    let lastItem;
    // 弹幕已经走的路程
    let distance;
    // 弹幕数据最终坐落的轨道索引
    // 有些弹幕会占多条轨道，所以 y 是个数组
    let y = [];
    for (let i = 0; i < this.tracks.length; i++) {
      track = this.tracks[i];
      if (track.length) {
        // 轨道被占用，要计算是否会重叠
        // 只需要跟轨道最后一条弹幕比较即可
        lastItem = track[track.length - 1];
        // 获取已滚动距离（即当前的 translateX）
        distance = -getTranslateX(lastItem.node);
        // 通过速度差，计算最后一条弹幕全部消失前，是否会与新增弹幕重叠
        // 如果不会重叠，则可以使用当前轨道 (追赶到 lastItem 的时间 > lastItem 运动完毕的时间)
        if (
          distance > lastItem.width &&
          (data.rollSpeed <= lastItem.rollSpeed ||
            (distance - lastItem.width) / (data.rollSpeed - lastItem.rollSpeed) >
              (this.wrapboxWidth + lastItem.width - distance) / lastItem.rollSpeed)
        ) {
          y.push(i);
        } else {
          y = [];
        }
      } else {
        // 轨道未被占用
        y.push(i);
      }
      // 有足够的轨道可以用时，就可以新增弹幕了，否则等下一次轮询
      if (y.length >= data.useTracks) {
        data.y = y;
        y.forEach(i => {
          this.tracks[i].push(data);
        });
        break;
      }
    }
  }

  renderEnd() {
    // 在轨道被填满之前，不会开启递归
    if (this.renderQueue.length > 0) {
      this.renderTimer = setTimeout(() => {
        this.render();
      }, 150);
    } else {
      // 如果已经没有数据，就不再轮询了，等有数据时（add 方法中）再开启轮询
      this.renderTimer = null;
    }
  }

  render() {
    try {
      this.renderToDom();
    } finally {
      this.renderEnd();
    }
  }
  /**
   * @description 根据id 获取弹幕数据
   * @param {*} y
   * @param {*} id
   * @returns {object}
   */
  findData(y, id) {
    const track = this.tracks[y];
    if (!track) {
      return;
    }
    for (let j = 0; j < track.length; j++) {
      if (track[j].increaseId === id) {
        return track[j];
      }
    }
  }

  /**
   * @description 遍历当前 渲染中的弹幕
   * @param {funciton} 对node 执行操作的回调函数
   *
   * */
  eachDanmakuNode(callback) {
    let child = this.container.firstChild;
    let id, y;
    while (child) {
      if (child.nodeType === 1) {
        y = child.getAttribute('data-y');
        id = child.getAttribute('data-increaseId');
        if (y && id) {
          callback(child, Number(y), id);
        }
      }
      child = child.nextSibling;
    }
  }

  /**
   * @description 单条暂停
   * @param {HTMLDivElement} node
   */
  itemPause(node, y, id) {
    // this.findData()
    const data = this.findData(y, id);
    if (data) {
      data.rolledDistance = '';
      data.rolledDistance = -getTranslateX(node);
      // 移除动画，计算出弹幕所在的位置，固定样式
      node.style.transition = '';
      node.style.transform = `translate3d(-${data.rolledDistance}px, 0, 0)`;
    }
  }

  /**
   * @description 单条暂停
   * @param {HTMLDivElement} node
   */
  itemResum(node, y, id) {
    if (this.paused) {
      return;
    }

    const data = this.findData(y, id);
    if (data) {
      data.startTime = Date.now();
      // 重新计算滚完剩余距离需要多少时间
      data.rollTime = (data.totalDistance - data.rolledDistance) / data.rollSpeed;
      node.style.transition = `transform ${data.rollTime}s linear`;
      node.style.transform = `translate3d(-${data.totalDistance}px,0,0)`;
    }
  }

  /**
   * @description 暂停 弹幕
   */
  pause() {
    if (this.resumeTimer) {
      clearTimeout(this.resumeTimer);
    }
    if (this.renderTimer) {
      clearTimeout(this.renderTimer);
      this.renderTimer = null;
    }
    // log.info('当前暂停状态', this.paused);
    // if (this.paused) { return; }
    this.paused = true;
    this.eachDanmakuNode((node, y, id) => {
      const data = this.findData(y, id);
      if (data) {
        // 获取已滚动距离
        data.rolledDistance = -getTranslateX(node);
        // 移除动画，计算出弹幕所在的位置，固定样式
        node.style.transition = '';
        node.style.transform = `translate3d(-${data.rolledDistance}px,0,0)`;
      }
    });
  }

  /**
   * @description 继续执行弹幕
   *
   */
  resume() {
    if (!this.player || !this.player.player) return;
    if (!this.paused) return;
    const playerStatus = this.player.getIsPaused();
    if (playerStatus) return;

    this.eachDanmakuNode((node, y, id) => {
      const data = this.findData(y, id);
      if (data) {
        data.startTime = Date.now();
        // 重新计算滚完剩余距离需要多少时间
        data.rollTime = (data.totalDistance - data.rolledDistance || 0) / data.rollSpeed;
        node.style.transition = `transform ${data.rollTime}s linear`;
        node.style.transform = `translate3d(-${data.totalDistance}px, 0, 0)`;
      }
    });
    this.paused = false;
    if (!this.renderTimer) {
      this.render();
    }
  }
  barrageState() {
    return this._isOpen;
  }

  /**
   * @description 清空弹幕
   * @returns {void}
   */
  clearBarrage() {
    // this.eachDanmakuNode((node, y, id) => {
    //   this.container.removeChild(node);
    // });
    try {
      const nodes = [];
      this.eachDanmakuNode(node => {
        nodes.push(node);
      });
      nodes.forEach(node => {
        this.container.removeChild(node);
      });
    } catch (e) {}
    this.renderQueue = [];
    this.computedTracks();
    // this.renderQueue = [];
    // this.container.innerHTML = '';
  }

  /**
   *  对弹幕数据进行 - 封装处理
   * @returns {object} 返回封装后的弹幕数据
   */
  parseData(content, style) {
    const msg = this.filterContent(content);
    const result = Object.assign(
      {
        increaseId: UUID.create()
      },
      {
        msg
      },
      this._barrageConfig,
      this._barrageConfig.style
    );

    // 解析单条弹幕自定义弹幕属性
    if (isMobile()) {
      style.h5FontSize && (result.h5FontSize = style.h5FontSize); // 字体大小
      style.h5Unit && (result.h5Unit = style.h5Unit); // 字体单位
    } else {
      style.fontSize && (result.fontSize = style.fontSize); // 字体大小
      style.unit && (result.unit = style.unit); // 字体单位
    }

    style.color && (result.color = style.color); // 字体颜色
    style.fontFamily && (result.fontFamily = style.fontFamily); // 弹幕字体
    style.opacity && (result.opacity = style.opacity); // 弹幕透明度
    if (style.opacity === 0) {
      result.opacity = 0;
    }
    style.backgroundColor && (result.backgroundColor = style.backgroundColor); // 弹幕背景色
    style.textShadow && (result.textShadow = style.textShadow); // 弹幕文字阴影
    style.padding && (result.padding = style.padding); // 文字左右边距
    style.backgroundImage && (result.backgroundImage = style.backgroundImage); // 字体渐变

    return result;
  }

  /**
   * @description 过滤传入内容中的 html 标记
   * @param {*} content
   * @returns
   */
  filterContent(content) {
    // 匹配除 img 外所有标签
    const reg = /<(?!img).*?>/gi;
    return content && content.replace(reg, '');
  }

  /**
   * @description 弹幕全局整体设置
   * @param {object} danmakuSetting 弹幕配置项 {   }
   */
  setBarrageInfo(danmakuSetting) {
    this._barrageConfig = Object.assign(
      {
        ...this._barrageConfig
      },
      {
        ...danmakuSetting
      }
    );

    // log.info('更新弹幕运动基础操作', JSON.stringify(this._barrageConfig));
    setTimeout(() => {
      this.clearBarrage();
    }, 10);
  }

  /**
   * 增加 弹幕
   */
  addBarrage(content, style = {}) {
    // 未播放 未开启弹幕功能  暂停中 均不增加弹幕
    if (!this._isPlaying || !this._isOpen || this.paused) {
      return false;
    }
    const data = this.parseData(content, style);
    this.renderQueue.push(data);
    // 启动 队列循环渲染
    if (!this.renderTimer) {
      this.render();
    }
  }

  /**
   * @description 开启弹幕
   */
  openBarrage() {
    !this._isOpen && (this._isOpen = true);
    this.player.emit2All('openbarrage');
  }

  /**
   * @description 关闭弹幕
   */
  closeBarrage() {
    this._isOpen = false;
    this.clearBarrage();
    this.player.emit2All('clearbarrage');
  }

  /**
   * AddEventListener
   * @description 绑定 - 事件监听 主要是 播放器的事件
   */
  addEventLisners() {
    // To Do
    // 增加播放器功能的- 支持。  监听播放器 - 播放暂停，增加弹幕同步操作
    this.player.on('play', this.playerPlay.bind(this));
    this.player.on('pause', this.playerPause.bind(this));
    this.player.on('ended', this.playerEnded.bind(this));
  }

  playerPlay() {
    this._isPlaying = true;
    if (!this._isOpen) {
      return;
    }
    if (this.paused) {
      this.resumeTimer = setTimeout(() => {
        this.resume();
      }, 200);
    }
  }

  playerPause() {
    if (this._isOpen) {
      this.pause();
    }
  }

  playerEnded() {
    if (this._isOpen) {
      this._isPlaying = false;
      this.clearBarrage();
    }
  }

  /**
   * 弹幕销毁
   */
  destroy() {
    super.destroy();
    removeFromParent(this.wrapbox);
  }

  /**
   * 定义插件类型
   */
  static get type() {
    return 'plugin_barrage';
  }
}
